import useSWR from 'swr'
import {useToken} from "../../../../app/hooks";
import API from "../../../../utils/api";
const M_KEY = '/board/inquiry/list'

const fetchKey = (id: number | string) => `${M_KEY}/${id}/answer`;

export function useAgentInquireAnswerInfo(id?: number | string) {
	const { data: token } = useToken();

	const key = id ? fetchKey(id) : null;

	const fetcher = ([requestKey, accessToken]: [string, string]) => fetchAPI(requestKey, accessToken || null);
	const { data, mutate } = useSWR(key ? [key, token ?? ''] : null, fetcher, { revalidateOnFocus: true });

	return { agentInquireAnswerInfo: data, mutateAgentInquireAnswerInfo: mutate };
}

async function fetchAPI(key: string, token?: string | null) {
	try {
		const response = await API.get(key, token ?? null, {});
		return response.result?.result;
	} catch (error) {
		console.error('Failed to fetch Agent Inquire Answer Info:', error);
		return { list: [], total: 0 };
	}
}
